<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item.label">
      <app-menu-item
        v-if="!item.separator"
        :item="item"
        :index="i"
      ></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
  </ul>
</template>

<script setup>
import { ref, computed } from 'vue';
import AppMenuItem from './AppMenuItem.vue';
import authService from '@/services/authService';
import { useRouter } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';
import { PROJECT_NETWORK_TEXTS } from '@/constants/projectNetworkConstants';


const router = useRouter();
const { can } = usePermissions();

const handleLogout = async () => {
  await authService.logout()
  router.push('/login')
};

const baseMenuItems = [
  {
    label: 'Projetos',
    icon: 'pi pi-fw pi-objects-column',
    to: '/projetos',
  },
  {
    label: 'Tarefas',
    icon: 'pi pi-fw pi-box',
    to: '/tarefas',
  },
  // {
  //   label: 'Entregáveis',
  //   icon: 'pi pi-fw pi-check-square',
  //   to: '/entregaveis',
  // },
  {
    label: 'Coordenação',
    icon: 'pi pi-fw pi-sitemap',
    to: '/coordenacao',
    permission: 'sistema.interface_aba_coordenador',
  },
  {
    label: 'Agenda',
    icon: 'pi pi-fw pi-calendar',
    to: '/agenda-eventos',
  },
  {
    label: PROJECT_NETWORK_TEXTS.menuLabel,
    icon: 'pi pi-fw pi-share-alt',
    to: '/midia/redes',
  },
  {
    label: 'Configurações de mídia',
    icon: 'pi pi-fw pi-megaphone',
    permission: 'sistema.midia_gerenciar',
    items: [
      {
        label: 'Meios',
        icon: 'pi pi-fw pi-sliders-h',
        to: '/midia/meios',
      },
      {
        label: 'Veículos',
        icon: 'pi pi-fw pi-send',
        to: '/midia/veiculos',
      },
      {
        label: 'Categorias de cobrança',
        icon: 'pi pi-fw pi-dollar',
        to: '/midia/categorias-cobranca',
      },
      {
        label: 'Clientes',
        icon: 'pi pi-fw pi-id-card',
        to: '/midia/clientes',
      },
      {
        label: 'Locais de cobrança',
        icon: 'pi pi-fw pi-map-marker',
        to: '/midia/locais-cobranca',
      },
      {
        label: 'Configurações gerais',
        icon: 'pi pi-fw pi-cog',
        to: '/midia/configuracoes',
      },
    ],
  },
  {
    label: 'Relatórios',
    icon: 'pi pi-fw pi-chart-bar',
    to: '/relatorios',
    permission: 'sistema.interface_relatorio',
  },
  {
    label: 'Usuarios',
    icon: 'pi pi-fw pi-id-card',
    to: '/usuario',
    permission: '',
  },
  {
    label: 'Logout',
    icon: 'pi pi-fw pi-sign-out',
    action: handleLogout,
  },
];

const model = computed(() => [
  {
    label: '',
    items: baseMenuItems.filter(item => {
      if (!item.permission) return true;
      return can(item.permission);
    }),
  },
]);
</script>
<style lang="scss" scoped></style>
